import { useState } from "react";
import { Loader2, PhoneCall } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function CallbackForm() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) { toast.error("Please add your name and phone."); return; }
    setLoading(true);
    try {
      await api.post("/submissions", { kind: "callback", name, phone, company });
      setDone(true);
    } catch { toast.error("Something went wrong. Please call 0431 206 206."); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div className="rounded-2xl border border-brand-line bg-brand-surface p-6 text-center" data-testid="callback-success">
      <PhoneCall className="mx-auto h-8 w-8 text-brand-gold" />
      <p className="mt-2 font-display font-bold text-brand-navy">Thanks — we'll call you back shortly.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className="rounded-2xl border border-brand-line bg-white p-6 shadow-lg" data-testid="callback-form">
      <h3 className="font-display text-lg font-extrabold text-brand-navy">Request a callback</h3>
      <p className="text-sm text-brand-muted">Just your name and number — we'll ring you.</p>
      <input type="text" tabIndex={-1} autoComplete="off" value={company} onChange={(e) => setCompany(e.target.value)} className="hidden" aria-hidden="true" />
      <div className="mt-4 space-y-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="w-full rounded-xl border-2 border-brand-line px-4 py-3 outline-none focus:border-brand-gold" data-testid="callback-name" />
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number" inputMode="tel" className="w-full rounded-xl border-2 border-brand-line px-4 py-3 outline-none focus:border-brand-gold" data-testid="callback-phone" />
        <button disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy px-6 py-3 font-bold text-white hover:bg-brand-navy2 transition-colors disabled:opacity-60" data-testid="callback-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <PhoneCall className="h-4 w-4" />} Call me back
        </button>
      </div>
    </form>
  );
}
